import { useEffect, useState } from "react";

/** The rendered width of an element, kept current as it resizes — so a component
 * can adapt to the space it actually has (a sidebar or devtools narrows it without
 * the window changing). 0 until measured. Falls back to window resizes where
 * ResizeObserver isn't available. */
export function useElementWidth(ref) {
  const [width, setWidth] = useState(0);
  useEffect(() => {
    const el = ref.current;
    if (!el) return undefined;
    const measure = () => setWidth(el.getBoundingClientRect().width);
    measure();
    if (typeof ResizeObserver === "undefined") {
      window.addEventListener("resize", measure);
      return () => window.removeEventListener("resize", measure);
    }
    const observer = new ResizeObserver(measure);
    observer.observe(el);
    return () => observer.disconnect();
  }, [ref]);
  return width;
}
